export default "__VITE_ASSET__P9cF7qQx__"